// Promo 4 — "The Pink Plan" (free lead magnet push)
import { PromoStage, FULL_PB, BgPhoto, PHOTOS } from "@/pages/promo/_stage";
import { motion } from "framer-motion";

const SLIDES = [
  {
    id: "open",
    duration: 2200,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white/85 uppercase tracking-[0.5em] text-sm font-semibold mb-8">
          / Free 7-day plan
        </motion.p>
        <motion.h1 initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          The<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "220px" }}>Pink</span><br />
          Plan.
        </motion.h1>
      </div>
    ),
  },
  {
    id: "what",
    duration: 2200,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col justify-center w-full h-full">
        <motion.p initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-8">
          / What's inside
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.9] tracking-tighter" style={{ fontSize: "120px" }}>
          7 days.<br />
          <span className="text-[#FF1B91]">3 workouts.</span><br />
          Zero excuses.
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.55 }} className="mt-8 text-white/65 text-2xl leading-snug">
          A 3-page PDF you can run with this week.
        </motion.p>
      </div>
    ),
  },
  {
    id: "bullets",
    duration: 2800,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col justify-center w-full h-full">
        <motion.p initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-6">
          / In the PDF
        </motion.p>
        {[
          "Full-body lift schedule",
          "Warm-up + cooldown flow",
          "Cardio cheat sheet",
          "Macro starter math",
        ].map((b, i) => (
          <motion.div
            key={b}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.25 + i * 0.18 }}
            className="flex items-center gap-6 py-5 border-b border-white/10"
          >
            <span className="font-display font-black text-[#FF1B91] text-3xl tracking-tighter w-12">0{i + 1}</span>
            <span className="font-display font-black uppercase text-white text-3xl tracking-tighter leading-none">{b}</span>
          </motion.div>
        ))}
      </div>
    ),
  },
  {
    id: "proof",
    duration: 2400,
    bg: "#0A0A0A",
    full: true,
    render: () => (
      <>
        <BgPhoto src={PHOTOS.hero} kenBurns="in" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/55 to-black/20" />
        <div className="absolute inset-0 flex flex-col justify-end px-16" style={{ paddingBottom: FULL_PB + 20 }}>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-5">
            / Built by
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.9] tracking-tighter" style={{ fontSize: "128px" }}>
            NASM. NFPT.<br />
            <span className="text-[#FF1B91]">CNC. CPR-AED.</span><br />
            Insured.
          </motion.h2>
        </div>
      </>
    ),
  },
  {
    id: "price",
    duration: 1800,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-base font-bold mb-6">
          / Price
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "320px" }}>
          $0
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.55 }} className="mt-6 text-white text-3xl font-bold uppercase tracking-tight">
          Just gimme your email.
        </motion.p>
      </div>
    ),
  },
  {
    id: "cta",
    duration: 3600,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-10">
          / Grab it
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          Pull<br />
          <span className="font-brush font-normal normal-case text-[#FF1B91] -rotate-3 inline-block" style={{ fontSize: "220px" }}>up.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.65 }} className="mt-10 text-white text-4xl font-bold tracking-tight">
          sweatwithslay.com
        </motion.p>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.95 }} className="mt-3 text-white/65 uppercase tracking-[0.4em] text-base font-semibold">
          @sweatwithslay
        </motion.p>
      </div>
    ),
  },
];

export default function Promo4() { return <PromoStage slides={SLIDES} />; }
